import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import PreventNav from './components/common/PreventNav';
import Nav from './components/nav/Nav';
import AddOnsContainer from './containers/AddOns';
import CheckoutContainer from './containers/Checkout';
import DateContainer from './containers/Date';
import Debug from './containers/Debug';
import GuestInfoContainer from './containers/GuestInfo';
import PackageContainer from './containers/Package';
import ReviewContainer from './containers/Review';
import ThanksContainer from './containers/Thanks';

const NotFound = () => (
  <div style={{ margin: '3em 1em' }}>
    Nothing exists here. Do you want to <Link to="/">start over</Link>?
  </div>
);

const App = ({ history }) => {
  return (
    <ConnectedRouter history={history}>
      <div className="accesso-tickets-app">
        <div className="swticketformwrap mw8 center">
          <Nav />
          <Switch>
            <Route exact path="/" component={DateContainer} />
            <Route path="/package" component={PackageContainer} />
            <Route path="/addons" component={AddOnsContainer} />
            <Route path="/guest-info" component={GuestInfoContainer} />
            <Route path="/review" component={ReviewContainer} />
            <Route path="/checkout" component={CheckoutContainer} />
            <Route path="/thanks" component={ThanksContainer} />
            <Route component={NotFound} />
          </Switch>
          <PreventNav />
          {process.env.NODE_ENV === 'development' && <Debug />}
        </div>
      </div>
    </ConnectedRouter>
  );
};

App.propTypes = {
  history: PropTypes.object,
  rootElement: PropTypes.object
};

export default hot(App);
